import React, { useState, useEffect, useRef } from 'react';
import TextField from "@material-ui/core/TextField";
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import Button from 'react-bootstrap-button-loader';
import i18next from 'i18next';
import AlertAlgo from '@controls/AlertSnack'

const useStyles = makeStyles((theme) => ({
    divRoot: {
        padding: '10px',
        borderRadius: '8px',
        width: '90%',
        margin: '0 auto',
        marginTop: '25px',
        marginBottom: '25px',
        boxShadow: '0 0 10px 0 #8f8f8f'
    },
    divTitle: {
        display: 'table',
        width: '100%'
    },
    divInput: {
        width: '100%',
        marginBottom: '20px'
    },
    divButton: {
        justifySelf: 'right'
    },
    spanError: {
        color: 'red'
    }
}));

function PdfViewerPassword(props) {

    const classes = useStyles();
    const [password, setPassword] = useState('');
    const alertRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        inputRef.current.focus();

        if (props.isErrorException) {
            setPassword('');

        }
    }, [])

    const handlePassword = () => {
        if (password !== '') {
            props.handlePassword(password);
        } else {
            alertRef.current.showMessageError(i18next.t('common:pdf.empty-password'));
        }
    }

    const onChangePassword = (event) => {
        setPassword(event.target.value);
    }

    return (
        <div className={classes.divRoot}>
            <div className={classes.divTitle}>{i18next.t('common:pdf.password')}</div>
            {props.isErrorException && <span className={classes.spanError}>{i18next.t('common:pdf.invalid-password')}</span>}
            <TextField
                inputRef={inputRef}
                id="password"
                className={classes.divInput}
                onChange={onChangePassword}
                value={password || ''}
            />
            <div className={classes.divButton}>
                <Button onClick={handlePassword}>Ok</Button>
            </div>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['common'], { wait: true })(PdfViewerPassword);